import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = { class: "d-flex flex-column" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12 mb-5" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "Notes:"),
    /*#__PURE__*/_createElementVNode("ol", null, [
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createTextVNode(" Choose Discount one between "),
        /*#__PURE__*/_createElementVNode("strong", null, "Amount"),
        /*#__PURE__*/_createTextVNode(" or "),
        /*#__PURE__*/_createElementVNode("strong", null, "Percent Off"),
        /*#__PURE__*/_createTextVNode(". ")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createTextVNode(" No of months applies to "),
        /*#__PURE__*/_createElementVNode("strong", null, "repeating"),
        /*#__PURE__*/_createTextVNode(" value for Duration. ")
      ])
    ])
  ])
], -1)
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "d-flex justify-content-end" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["onClick", "data-kt-indicator", "disabled"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Save ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormField = _resolveComponent("FormField")!
  const _component_DurationSelect = _resolveComponent("DurationSelect")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, {
    "validation-schema": _ctx.formSchema,
    "initial-values": _ctx.formData,
    ref: "updatePromoForm"
  }, {
    default: _withCtx(({ handleSubmit, validate, values }) => [
      _createElementVNode("form", {
        onSubmit: _withModifiers(($event: any) => (handleSubmit(_ctx.submitForm)), ["prevent"]),
        class: "form w-100 fv-plugins-bootstrap5 fv-plugins-framework",
        id: "update-promo-form",
        novalidate: ""
      }, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_FormField, {
              required: false,
              name: _ctx.addPrefix('name', _ctx.prefix),
              containerClass: "col-lg-3 col-md-4 col-12",
              label: "Name",
              placeholder: "Name"
            }, null, 8, ["name"]),
            _createVNode(_component_FormField, {
              required: false,
              name: _ctx.addPrefix('code', _ctx.prefix),
              containerClass: "col-lg-3 col-md-4 col-12",
              label: "Code",
              placeholder: "Code",
              disabled: true
            }, null, 8, ["name"]),
            _createVNode(_component_FormField, {
              required: false,
              name: _ctx.addPrefix('quantity', _ctx.prefix),
              containerClass: "col-lg-3 col-md-4 col-12",
              label: "Quantity",
              placeholder: "Quantity",
              type: "number",
              disabled: true
            }, null, 8, ["name"]),
            _createVNode(_component_FormField, {
              required: false,
              name: _ctx.addPrefix('max_redemptions', _ctx.prefix),
              containerClass: "col-lg-3 col-md-4 col-12",
              label: "Max Redemptions",
              placeholder: "Max Redemptions",
              type: "number"
            }, null, 8, ["name"]),
            _createVNode(_component_FormField, {
              required: false,
              name: _ctx.addPrefix('amount_off', _ctx.prefix),
              containerClass: "col-lg-3 col-md-4 col-12",
              label: "Discount Amount (AUD)",
              placeholder: "Amount (AUD)",
              type: "number",
              disabled: true
            }, null, 8, ["name"]),
            _createVNode(_component_FormField, {
              required: false,
              name: _ctx.addPrefix('percent_off', _ctx.prefix),
              containerClass: "col-lg-3 col-md-4 col-12",
              label: " Percent Off (%)",
              placeholder: " Percent Off (%)",
              type: "number",
              disabled: true
            }, null, 8, ["name"]),
            _createVNode(_component_DurationSelect, {
              containerClass: "col-lg-3 col-md-4 col-12",
              label: "Duration",
              name: _ctx.addPrefix('duration', _ctx.prefix),
              required: true,
              value: values.duration,
              onSelectChange: _ctx.handleSelectDuration,
              onSelectCloseOrDeselect: _ctx.handleCloseDuration,
              type: "multiselect",
              "show-label": true,
              disabled: true
            }, null, 8, ["name", "value", "onSelectChange", "onSelectCloseOrDeselect"]),
            _createVNode(_component_FormField, {
              required: false,
              name: _ctx.addPrefix('duration_in_months', _ctx.prefix),
              containerClass: "col-lg-3 col-md-4 col-12",
              label: "No of Months",
              placeholder: "No of Months",
              type: "number",
              disabled: true
            }, null, 8, ["name"]),
            _createVNode(_component_FormField, {
              required: false,
              name: _ctx.addPrefix('description', _ctx.prefix),
              containerClass: "col-lg-12 col-md-12 col-12",
              label: "Description",
              placeholder: "Description",
              type: "textarea"
            }, null, 8, ["name"])
          ]),
          _createVNode(_component_el_divider),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("a", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleCancel && _ctx.handleCancel(...args))),
              class: "btn btn-white me-3",
              disabled: _ctx.loading
            }, " Cancel ", 8, _hoisted_6),
            _createElementVNode("button", {
              onClick: validate,
              "data-kt-indicator": _ctx.loading ? 'on' : null,
              class: "btn btn-lg btn-primary fw-bolder me-4",
              disabled: _ctx.loading
            }, _hoisted_10, 8, _hoisted_7)
          ])
        ])
      ], 40, _hoisted_1)
    ]),
    _: 1
  }, 8, ["validation-schema", "initial-values"]))
}